<template>
  <div id="admin-exam-read">
    <!-- 阅卷 -->
    <diy_table
      :loading="loading"
      :tipData="tipData"
      :active="active"
      :searchData="searchData"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :pageData="pageData"
      @handleClickTop="handleClickTop"
      @showActive="showActive"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>
  </div>
</template>

<script>
import * as examData from "./js/exam.js";
import * as base from "../js/base.js";
export default {
  data() {
    return {
      tipData: [
        { text: "全部", key: "0" },
        { text: "待阅卷", key: "3" },
        { text: "已阅卷", key: "4" },
      ],
      loading: false,
      active: "0",
      searchData: examData.getSearchData("read"),
      tableMenu: examData.getQuestionTableMenu(),
      tableData: examData.initTableData(),
      tableButton: examData.getTableBUttonList("read"),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 总条目数
      },

      tempQuestion: {},
    };
  },
  methods: {
    // 权限设置  获取部门设置界面所有子界面的权限  考试管理 51
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "51" },
        });
        this.tableButton = base.returnAllButton(
          this.tableButton,
          resultData,
          "text"
        );
      } catch (error) {}
    },
    /**
     * 初始化表格数据
     */
    async initTable(data) {
      this.loading = true;
      try {
        setTimeout(async () => {
          let requestData = {
            status: this.active == "0" ? "" : this.active,
            currentPage: data.pageData.currentPage,
            pageSize: data.pageData.pageSize,
          };
          requestData = this.$baseData.array2json(data.searchData, requestData);
          console.log(requestData);
          if (requestData.time == null || requestData.time.length == 0) {
            requestData.time = ["", ""];
          }
          let resultData = await this.$request({
            url: "/teacherExam/getAllExamListForReadTeacher",
            method: "post",
            data: requestData,
          });
          this.tableData = resultData.tableData;
          this.pageData.total = resultData.total;
          this.loading = false;
        }, 300);
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 搜索框旁边的按钮操作
     */
    handleClickTop(active) {
      switch (active) {
        case "create":
          // 新增科目
          this.$router.push({
            path: "/admin/exam-index/read-student",
            query: {
              id: "",
            },
          });
          break;

        default:
          break;
      }
    },
    /**
     * 表格中的操作事件
     */
    async handleClick(data) {
      try {
        this.tempQuestion = JSON.parse(JSON.stringify(data.item));
        switch (data.active) {
          case "read_paper":
            // 阅卷
            this.$router.push({
              path: "/admin/exam-index/read-student",
              query: {
                id: this.tempQuestion.id,
              },
            });
            break;
          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * active的监听事件
     */
    showActive(data) {
      this.active = data;
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    await this.initTable({
      pageData: this.pageData,
      searchData: this.searchData,
    });
    sessionStorage.removeItem("eaxmId");
  },
};
</script>

<style lang="less" scoped>
#admin-exam-read {
  width: 100%;
  height: 100%;
}
</style>